export type SicCode = {
  groupID?: string;
  caseNumber?: string | null;
  description?: string | null;
  sicCodeValue: ValidSicCodeValue | InvalidSicCodeValue;
};

const SicCodeLength = 4;

export class ValidSicCodeValue {
  public static create(value?: string | null) {
    return Number.isInteger(Number(value)) && value?.length === SicCodeLength
      ? new ValidSicCodeValue(value)
      : new InvalidSicCodeValue(value);
  }

  private constructor(public readonly value: string) {}
}

export class InvalidSicCodeValue {
  public readonly validationError = 'SIC Code must be a four digit number';

  public constructor(public readonly value: string | undefined | null) {}
}
